export enum Constants {
  LOAD_USER_REQUEST = '@@user/LOAD_USER_REQUEST',
  LOAD_USER_SUCCESS = '@@user/LOAD_USER_SUCCESS',
  LOAD_USER_FAILURE = '@@user/LOAD_USER_FAILURE',
}
